module.exports = __webpack_public_path__ + "img/MS_WeaponSword010.945e231e.png";